import React, { useCallback } from 'react';
import { ListItemIcon, ListItemText, Link, MenuItem } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import { useFeatureFlag } from 'modules/common/hooks';

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: 'none',
    color: theme.palette.text.primary
  },
  menuItem: {
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    }
  }
}));

export const DownloadMenuItem = (): JSX.Element => {
  const linkClasses = useStyles();
  const isTiwVpatEnabled = useFeatureFlag('isTiwVpatEnabled');
  const downloadClick = useCallback(() => {
    window.open('/download', '_blank')?.focus();
  }, []);

  return (
    <>
      {isTiwVpatEnabled ? (
        <MenuItem
          data-testid="download-menu"
          className={linkClasses.menuItem}
          onClick={downloadClick}
        >
          <ListItemIcon>
            <DownloadIcon data-testid={'download-icon'} />
          </ListItemIcon>
          <ListItemText>
            <FormattedMessage id="appMenu.desktopApp" />
          </ListItemText>
        </MenuItem>
      ) : (
        <Link
          href={'/download'}
          target="_blank"
          color="primary"
          underline="none"
          data-testid="download-menu-item"
          className={linkClasses.link}
        >
          <MenuItem
            data-testid="download-menu"
            className={linkClasses.menuItem}
          >
            <ListItemIcon>
              <DownloadIcon data-testid={'download-icon'} />
            </ListItemIcon>
            <ListItemText>
              <FormattedMessage id="appMenu.desktopApp" />
            </ListItemText>
          </MenuItem>
        </Link>
      )}
    </>
  );
};
